import React from "react";
import styles from "./InputTextArea.module.scss";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const InputTextArea = (props) => {
  const {
    control,
    register,
    validations,
    label,
    name,
    icon,
    placeholder,
    isRequired,
    type,
    ...rest
  } = props;

  const { droppedItems, selectedData } = useSelector((state) => state.form);
  const value = droppedItems?.filter(
    (item) => item?.data?.id == selectedData?.id
  );
  const instructionValues = () => {
    let values;
    if (value[0]?.name === "Instructions") {
      values = value[0]?.data?.value;
    } else {
      values = value[0]?.data?.instructions;
    }
    return values;
  };

  return (
    <div className={styles?.textarea}>
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => (
          <textarea
            {...field}
            {...rest}
            id={name}
            //   type='textarea'
            className={props?.className}
            // value={value[0]?.data?.instructions || ''}
            defaultValue={instructionValues()}
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
};

export default InputTextArea;
